import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../../assets/images/home/favicon.png'


const _hoisted_1 = { class: "auth-experience" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", null, "Sanvault", -1)
const _hoisted_4 = /*#__PURE__*/_createStaticVNode("<section class=\"auth-value-panel\"><div class=\"auth-value-panel__content\"><span class=\"auth-kicker\">E-mail enviado</span><h1>As instruções já estão a caminho.</h1><p> Verifique sua caixa de entrada e siga o processo indicado para recuperar o acesso à plataforma. </p><div class=\"auth-value-list\"><span><i class=\"ph ph-envelope-open\"></i> Consulte também a caixa de spam</span><span><i class=\"ph ph-clock\"></i> O envio pode levar alguns instantes</span><span><i class=\"ph ph-shield-check\"></i> Link individual e protegido</span></div></div></section>", 1)
const _hoisted_5 = {
  class: "auth-form-panel",
  "aria-label": "Confirmação do envio"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_ForgotPasswordSendEmail = _resolveComponent("ForgotPasswordSendEmail")!

  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _createVNode(_component_router_link, {
      to: "/",
      class: "auth-brand",
      "aria-label": "Voltar para a página inicial da Sanvault"
    }, {
      default: _withCtx(() => [
        _hoisted_2,
        _hoisted_3
      ]),
      _: 1
    }),
    _hoisted_4,
    _createElementVNode("section", _hoisted_5, [
      _createVNode(_component_ForgotPasswordSendEmail)
    ])
  ]))
}